import { checkAuthUser } from '@/app/api';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IUser } from '../types/user/types';

interface IAuthState {
  isAuth: boolean;
  loading: boolean;
  user: IUser;
}

const initialState: IAuthState = {
  isAuth: false,
  loading: true,
  user: {} as IUser,
};

export const fetchCheckAuthUser = createAsyncThunk(
  'auth/fetchCheckUser',
  async () => {
    const response = await checkAuthUser();
    return response.data;
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setIsAuth: (state, action: PayloadAction<boolean>) => {
      state.isAuth = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCheckAuthUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCheckAuthUser.fulfilled, (state, action) => {
        state.isAuth = true;
        state.user = action.payload.user;
        state.loading = false;
      })
      .addCase(fetchCheckAuthUser.rejected, (state) => {
        state.isAuth = false;
        state.loading = false;
      });
  },
});

export const selectIsAuth = (state: RootState) => state.auth.isAuth;
export const selectUser = (state: RootState) => state.auth.user;

export const { setIsAuth } = authSlice.actions;

export default authSlice.reducer;
